var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLaptop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "translate(-1, 0)",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5H11.5V14V24V24.5H12H28.001H28.501L28.501 24L28.5 14L28.5 13.5H28H12ZM28 25.5H12C11.1731 25.5 10.5 24.8269 10.5 24V14C10.5 13.1731 11.1731 12.5 12 12.5H28C28.8269 12.5 29.5 13.1731 29.5 14V24C29.5 24.8269 28.8269 25.5 28 25.5ZM12 26.5H28H31.5V27.5H8.5V26.5H12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.7843V17.1506L21.4369 18.9584L20.8171 19.0118L20.7369 19.0188L20.663 19.0504L20.033 19.3204L19.9505 19.3558L19.8854 19.4177L19.5 19.7843Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5421 21.8929L20.2451 18.8929L21.5421 21.8929Z",
    stroke: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5421 21.8929L20.2451 18.8929",
    strokeMiterlimit: 10
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLaptop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/laptop.beae91e09c8309b47d08a73ad13f8d5d.svg";